/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Component, input } from '@angular/core';
import { IconComponent, IconConfig } from '../../icon/icon.component';
import { ButtonIconName } from '../../icon/icons';

@Component({
  selector: 'ods-dropdown-menu-text-item',
  host: {
    role: 'listitem',
    class:
      'flex min-h-12 items-start gap-4 px-4 py-3 text-start border-b-grayborder border-t-grayborder bg-whitetext border-b first:border-t',
  },
  imports: [IconComponent],
  template: `
    @if (icon(); as iconName) {
      <ods-icon [name]="iconName" [config]="iconConfig()" />
    }
    <div class="w-80 whitespace-normal">
      <p class="mb-1 text-base font-medium">{{ title() }}</p>
      <p class="mb-3 text-sm font-normal">{{ description() }}</p>
      <ng-content select="[additionalContent]" />
    </div>
  `,
})
export class DropdownMenuTextItemComponent {
  public readonly title = input.required<string>();
  public readonly description = input.required<string>();
  public readonly icon = input<ButtonIconName>();
  public readonly iconConfig = input<IconConfig>();
}
